import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import firebase from "firebase";


import {
  LOAD_PROJECT_LIST, LOAD_PROJECT_SUCCESS
} from "constants/ActionTypes";

import {
  loadProjectListSuccess,
} from "../actions/MyProjects";


export function* loadMyProjects() {
  yield takeEvery(LOAD_PROJECT_LIST, loadProjectByID);
}

function* loadProjectByID( userID) {

  const {payload} = userID;
  console.log("*********** SONO IN SCRITTURA COMPLETATA");
  var projectsRef = firebase.database().ref('/projects/'+payload+'')
  var projects = yield call(function() {
    return new Promise(function(resolve, reject) {
      projectsRef.once('value', function (snap) {
      
        var projects = snap;
        resolve(projects)
      })
    })
  })
  yield put(loadProjectListSuccess(projects))

 

}

export default function* rootSaga() {
  yield all([fork(loadMyProjects)]);
}

